import React from 'react';
import throttle from 'lodash/throttle';
import { LocalStorageService } from '@uplift/services';
import { useIntervalMemo } from '@uplift/hooks';
import { AutoLogoutNotificationModal } from './auto-logout-notification.component';


export const AutoLogoutContext = React.createContext({ enabled: true, timeout: 15 });
export const AutoLogoutSendEnabledRequestContext = React.createContext<(v: boolean) => void>(() => undefined);


export type AutoLogoutProviderProps = {
  logoutModalTimeout?: number;
};


export const AutoLogoutProvider: React.FC<AutoLogoutProviderProps> = ({ children, logoutModalTimeout = 15 }) => {
  const isEnabled = useIntervalMemo(() => {
    const lastDisablingRequest = LocalStorageService.getItem<number>('lastDisablingRequest') ?? 0;
    const lastDisablingDiffMs = Date.now() - (lastDisablingRequest ?? 0);

    return lastDisablingDiffMs > 3000;
  }, 3000);

  const sendIsEnabledRequest = React.useMemo(() => throttle((enabled: boolean) => {
    if (enabled) {
      LocalStorageService.setItem('lastDisablingRequest', 0);
    } else {
      LocalStorageService.setItem('lastDisablingRequest', Date.now());
    }
  }, 2000), []);

  const value = React.useMemo(() => ({
    enabled: isEnabled || false,
    timeout: logoutModalTimeout,
  }), [ isEnabled, logoutModalTimeout ]);

  return (
    <AutoLogoutContext.Provider value={value}>
      <AutoLogoutSendEnabledRequestContext.Provider value={sendIsEnabledRequest}>
        {children}
        <AutoLogoutNotificationModal enabled={isEnabled} />
      </AutoLogoutSendEnabledRequestContext.Provider>
    </AutoLogoutContext.Provider>
  );
};
